import React from "react";
import {
  Col,
  Image,
  Row,
  //   theme,
} from "antd";
import PaymentLogo from "../../assets/images/payment-reminders.webp";

const PaymentReminders = () => {
  return (
    <React.Fragment>
      <Col span={24} className="mt-[50px] mb-[50px]">
        <Row>
          <Col span={12}>
            <Image src={PaymentLogo} height={350} width={450} preview={false} />
          </Col>
          <Col span={12} className="mt-6">
            <h1 className="text-start leading-tight text-[#314259] text-[48px] font-extrabold">
              Send Payment Reminders to Recover Dues
            </h1>
            <p className="mt-6 text-start text-[#787878] text-[20px] font-semibold">
              Mbook accounting and billing software help SMEs ensure timely
              payments and maintain cash flow. Mbook does it for you by helping
              you track of all due payments in the business dashboard.
            </p>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};
export default PaymentReminders;
